__turbopack_context__.v({
  "feature": "features-module-scss-module__lzSJrW__feature",
  "featureIcon": "features-module-scss-module__lzSJrW__featureIcon",
  "featureText": "features-module-scss-module__lzSJrW__featureText",
  "featuresList": "features-module-scss-module__lzSJrW__featuresList",
  "featuresWrp": "features-module-scss-module__lzSJrW__featuresWrp",
});
